import { lazy, Suspense, useState } from "react";
import { Button } from "../../elements/Button";
import { useEntityPage } from "../useEntityPage";

// Lazy so the record definition doesn't pull the service layer in behind every page.
const ActivationModal = lazy(() => import("./ActivationModal"));

function useActivation() {
  const { record, onRefresh } = useEntityPage();
  const [open, setOpen] = useState(false);

  const modal = open && record && (
    <Suspense fallback={null}>
      <ActivationModal
        record={record}
        onClose={() => setOpen(false)}
        onDone={onRefresh}
      />
    </Suspense>
  );

  return { record, modal, openModal: () => setOpen(true) };
}

/** The organisation's customer id, with the way to activate it again. */
export function CustomerId() {
  const { record, modal, openModal } = useActivation();

  return (
    <>
      <p className="mb-0">
        {String(record?.g4c_customerid ?? "")}{" "}
        <button type="button" className="btn btn-link p-0 align-baseline" onClick={openModal}>
          Reactivate
        </button>
      </p>
      {modal}
    </>
  );
}

/** What an organisation that hasn't activated email marketing sees, and how it does. */
export function ActivationNotice() {
  const { modal, openModal } = useActivation();

  return (
    <>
      <div className="alert alert-warning mb-3">
        Please enter an activation code to enable Email Marketing.
      </div>
      <Button text="Activate" variant="primary" onClick={openModal} />
      {modal}
    </>
  );
}
